import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { LockClosedIcon, WrenchScrewdriverIcon } from '@heroicons/react/24/outline';

/**
 * Shown when the user is locked out (seat limit) or site is in maintenance mode.
 * Pass `maintenance` prop to show the maintenance variant.
 */
export default function LockedOutScreen({ maintenance = false }) {
  const handleSignOut = () => {
    signOut(auth);
  };

  return (
    <div className="min-h-screen gch-layout-bg flex items-center justify-center p-6" style={{ fontFamily: '"Inter", sans-serif' }}>
      <div className="max-w-md w-full gch-card rounded-2xl p-8 text-center">
        {maintenance ? (
          <>
            <div className="w-14 h-14 mx-auto mb-6 rounded-2xl bg-amber-500/10 flex items-center justify-center">
              <WrenchScrewdriverIcon className="w-8 h-8 text-amber-400" />
            </div>
            <h1 className="text-xl font-semibold gch-text-primary mb-2" style={{ fontFamily: '"Lexend", sans-serif' }}>
              We'll be right back
            </h1>
            <p className="text-sm gch-text-secondary mb-6">
              SmilesFlow is currently undergoing scheduled maintenance. Please check back shortly.
            </p>
          </>
        ) : (
          <>
            <div className="w-14 h-14 mx-auto mb-6 rounded-2xl bg-[var(--admin-cta-solid)]/10 flex items-center justify-center">
              <LockClosedIcon className="w-8 h-8 text-[var(--admin-cta-solid)]" />
            </div>
            <h1 className="text-xl font-semibold gch-text-primary mb-2" style={{ fontFamily: '"Lexend", sans-serif' }}>
              Account access limited
            </h1>
            <p className="text-sm gch-text-secondary mb-6">
              Your plan allows 1 active user. The account owner has locked your access. They can enable you again from Settings → Users by swapping who is active.
            </p>
          </>
        )}
        <button
          type="button"
          onClick={handleSignOut}
          className="btn-admin-outline btn-admin-md"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
